/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
export enum OneAppPermission {
  COMPANY_READ = 'company:read',
  COMPANY_WRITE = 'company:write',

  WORKFLOW_READ = 'workflow:read',
  WORKFLOW_WRITE = 'workflow:write',
  WORKFLOW_DELETE = 'workflow:delete',

  TASK_READ = 'task:read',
  TASK_DELETE = 'task:delete',
  TASK_CLAIM = 'task:claim',

  TASK_STATIC_DATA_WRITE = 'taskstaticdata:write',

  TASK_PROCESS_DATA_WRITE = 'taskprocessdata:write',

  EMPLOYEE_READ = 'employee:read',
  EMPLOYEE_WRITE = 'employee:write',
  EMPLOYEE_DELETE = 'employee:delete',

  EMPLOYEEGROUP_READ = 'employeegroup:read',
  EMPLOYEEGROUP_WRITE = 'employeegroup:write',
  EMPLOYEEGROUP_DELETE = 'employeegroup:delete',

  AUDITTRAIL_READ = 'audittrail:read',

  NOTIFICATION_READ = 'notification:read',
  NOTIFICATION_WRITE = 'notification:write',
  NOTIFICATION_DELETE = 'notification:delete',

  PERMISSION_READ = 'permission:read',
  PERMISSION_WRITE = 'permission:write',
  PERMISSION_DELETE = 'permission:delete',

  STARTSCREEN_READ = 'startscreen:read',

  IMAGE_FETCH = 'image:read',

  APP_USE = 'app:use',
  WEB_USE = 'web:use',
  VOICE_USE = 'voice:use',
  UNKNOWN = 'unknown'
}
